import React, { Component } from 'react';

class EmbeddedSessionExpiredModal extends Component {
  static modalType() {
    return null;
  }

  static reducer() {
    return null;
  }

  static title() {
    return 'Session expired';
  }

  render() {
    return (
      <div>
        <h5>
          You've been logged out. Refresh the page or click "Re-authenticate"
        </h5>
        <button
          type="button"
          className="btn btn-primary"
          data-bs-dismiss="modal"
          onClick={() => window.location.reload()}
        >
          Re-authenticate
        </button>
      </div>
    );
  }
}

export default EmbeddedSessionExpiredModal;
